import  { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  TextField,
  Button,
  Box,
  Typography,
  Paper,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import SaveIcon from "@mui/icons-material/Save";
import axios from "axios";
import Loader from "../utils/Loader";

const AssessmentDialog = ({
  open,
  onClose,
  onSave,
  isLoading,
  itemId,
  level,
}) => {
  const BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const [description, setDescription] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [loadingSuggestions, setLoadingSuggestions] = useState(false);

  // تصفير الحقل وجلب المقترحات عند فتح النافذة
  useEffect(() => {
    if (open) {
      setDescription("");
      setSuggestions([]);

      if (itemId && level) {
        fetchSuggestions();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, itemId, level]);

  // دالة جلب المقترحات من الخادم
  const fetchSuggestions = async () => {
    setLoadingSuggestions(true);
    try {
      // 1. استخراج التوكن من LocalStorage (بناءً على اسم المفتاح في صورتك)
      const token = localStorage.getItem("userToken");

      // 2. إرسال الطلب مع إرفاق التوكن في الـ Headers
      const response = await axios.get(
        `${BASE_URL}assessment-results/${itemId}?level=${level}`,
        {
          headers: {
            Authorization: `Bearer ${token}`, // تأكد إذا كان السيرفر يقبل Bearer أو التوكن مباشرة
          },
        },
      );

      const criteriaData =
        response.data?.data?.assessmentCriteria?.criteriaDescription;

      // استخراج حقل title فقط كنصوص
      if (Array.isArray(criteriaData)) {
        const textSuggestions = criteriaData.map((item) => item.title);
        setSuggestions(textSuggestions);
      }
    } catch (error) {
      console.error("حدث خطأ أثناء جلب المقترحات:", error);
    } finally {
      setLoadingSuggestions(false);
    }
  };

  const handleSave = () => {
    if (description.trim() !== "") {
      onSave(description);
    }
  };

  // دالة التعامل مع النقر على المقترح
  const handleSuggestionClick = (text) => {
    setDescription(text);
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      slotProps={{
        paper: {
          variant: "section", // التوريث من الثيم الخاص بك
        },
      }}
      maxWidth="sm"
    >
      <DialogTitle
        sx={{
          m: 0,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        إضافة وصف التقييم
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{ color: (theme) => theme.palette.grey[500] }}
        >
          <CloseIcon color="warning" />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers>
        {/* قسم عرض المقترحات */}
        <Box sx={{ mb: 3 }}>
          <Typography variant="sectionTitle">
            العبارات المقترحة:
          </Typography>

          {loadingSuggestions ? (
            <Loader/>
          ) : suggestions.length > 0 ? (
            <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
              {suggestions.map((text, index) => (
                <Paper
                variant="glass"
                  key={index}
                  label={text}
                  onClick={() => handleSuggestionClick(text)}
                  color="primary"
                  sx={{
                    cursor: "pointer",
                    height: "auto",
                    "& .MuiChip-label": {
                      whiteSpace: "normal",
                      display: "block",
                      padding: "8px",
                    },
                  }}
                >
                  <Typography>{text}</Typography>
                </Paper>
              ))}
            </Box>
          ) : (
            <Typography variant="caption" color="text.secondary">
              لا توجد مقترحات متاحة حالياً.
            </Typography>
          )}
        </Box>

        <TextField
        variant="outlined"
          autoFocus
          label="تفاصيل التقييم"
          multiline
          rows={4}
          fullWidth
          placeholder="اكتب ملاحظاتك ووصف التقييم للطالب هنا..."
          value={description}
          onChange={(e) => setDescription(e.target.value)}
        />
      </DialogContent>

      <DialogActions >
        <Button size="small" onClick={onClose} variant="outlined" color="warning">
          إلغاء
        </Button>
        <Button
        size="small"
          onClick={handleSave}
          variant="contained"
          color="secondary"
          startIcon={
            isLoading ? (
              <Loader/>
            ) : (
              <SaveIcon sx={{ml:'10px'}} />
            )
          }
          disabled={isLoading || !description.trim()}
        >
          {isLoading ? "جاري الحفظ..." : "حفظ الوصف"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AssessmentDialog;
